import { useDispatch } from "react-redux";
import CardHeaderBG from "../../../components/components-library/card-header-bg";
import TotalsWeightcards from "./totals-cards-details";
import TotalsCard from "../../../components/components-library/totals-card";
import { useState } from "react";
import { Button } from "../../../components/ui";
import PercentageBar from "./percentage-bar/percentage";
import useComposition from "./useComposition";
import { updateCategoryWeight } from "../../../reducers/riskEngineSlice";
import { SettingsBackupRestore } from "@mui/icons-material";

const Composition = () => {
  const { categoryWeights, handleSave, compositionsData, handleResetWeights } =
    useComposition();
  const dispatch = useDispatch();
  return (
    <>
      {" "}
      <div className="outlet_padding">
        <CardHeaderBG
          titile="Weightage Composition"
          titileClassName="bg-oceangreen "
        >
          <div className="card_space_18">
            <TotalsWeightcards totals={compositionsData?.totals ?? null} />
            <div className="border card_space_18 br-10 bg-white space_18">
              <div className="flex justify-between items-center">
                <span>Categories</span>
                <Button
                  variant="outlined-primary"
                  onClick={() => {
                    handleResetWeights();
                  }}
                >
                  <SettingsBackupRestore className="color-primary" /> Reset
                  Weights
                </Button>
              </div>
              <div className="w-full grid grid-cols-2 gap-4 pt-[18px]">
                {compositionsData?.categories.map((item) => (
                  <div>
                    <PercentageBar
                      label={item.category_name}
                      value={item?.weight}
                      onChange={(val) =>
                        dispatch(
                          updateCategoryWeight({
                            key: item.category_name,
                            value: val,
                          })
                        )
                      }
                      totalParams={item.total_parameters}
                      totalRules={item.total_rules}
                    />
                  </div>
                ))}
              </div>

              <div className="mt-8 flex justify-end">
                <Button
                  onClick={() => {
                    handleSave();
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </CardHeaderBG>
      </div>
    </>
  );
};
export default Composition;
